import React from "react";
import {getBrowserLocales} from "./helpers";

export const BrowserLocalesContext = React.createContext<string[]>(getBrowserLocales());